// The subtitle lines stamped with THIS device's time of receipt, as an external store: React
// reads it with useSyncExternalStore and the room feeds it from an effect, so the clock (an
// external system) is never read during render. The interpreter's own stamps come from its
// clock, which may be seconds off this device's; the captions' lifetimes count from here.

import { withLocalTimes, type SeenStamp, type SubtitleLine } from './streams';

export class LocalTimes {
  private readonly seen = new Map<string, SeenStamp>();
  private readonly listeners = new Set<() => void>();
  private snapshot: readonly SubtitleLine[] = [];

  constructor(private readonly now: () => number = () => Date.now()) {}

  /** The lines as last fed, with local times. Stable between updates (useSyncExternalStore). */
  readonly getSnapshot = (): readonly SubtitleLine[] => this.snapshot;

  readonly subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  /** Feed the lines as collected from the streams; subscribers are told when they changed. */
  update(lines: readonly SubtitleLine[]): void {
    this.snapshot = withLocalTimes(lines, this.seen, this.now());
    for (const listener of this.listeners) listener();
  }
}
